import Vue from "vue";
export default {
  install(app) {
    Vue.prototype.$eventBus = new Vue();
  }
};



// WEBPACK FOOTER //
// ./src/plugins/emit.js